// Core
import React from 'react';

// Components
import { GeckoIcon } from '@geckolabs/gecko-react-ui';

// Styles
import './styles.css';


const WithIcon = (props) => {
    return (
        <div className="WithIcon-container">
            <div className="WithIcon-iconWrapper" style={{fontSize: `${props.size}px`}}>
                <GeckoIcon icon={props.icon} />
            </div>

            <div>
                {props.children}
            </div>
        </div>
    );
}

WithIcon.defaultProps = {
    icon: null,
    size: 16, // icon font size
}

export default WithIcon;
